module.exports = "/_next/static/images/1a1c8d5bda3c3fda3ca7b66a16cd5a58-hands-holding-cards-md@1x.jpg";